export default __webpack_public_path__ + "static/media/lock_svg.a5fe3ef3.svg";